import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Add } from "@mui/icons-material";
import { Grid, Button } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import {
  AppSyncSearchQuery,
  AppSyncSearchResult,
} from "@commr/admin/models/common/appSyncSearch";
import { getAdminsByParameters } from "@commr/admin/services/adminService";
import { Residency } from "@commr/admin/models/residency/residency";
import CustomSearchHeader from "../common/customSearchHeader/customSearchHeader";
import SearchedUserResult from "../common/search/searchResult";
import AdminHit from "./adminHit";

interface Props {
  residency: Residency;
  addPath: string;
  isSuper: boolean;
}

const AdminsContainer: React.FC<React.PropsWithChildren<Props>> = ({
  residency,
  addPath,
  isSuper,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [searchResult, setSearchResult] = useState<AppSyncSearchResult>();
  const [searchQuery, setSearchQuery] = useState<AppSyncSearchQuery>(
    new AppSyncSearchQuery()
  );

  useEffect(() => {
    if (searchQuery) {
      getAdminsByParameters(searchQuery, residency.externalId, isSuper).then(
        (result: AppSyncSearchResult) => {
          setSearchResult(result);
        }
      );
    }
  }, [searchQuery]);

  const onAddClicked = () => {
    history.push(addPath);
  };

  return (
    <div className="admins-container">
      <CustomSearchHeader setSearchQuery={setSearchQuery} />
      <Grid item xs={2} sx={{ paddingTop: 1, paddingBottom: 1 }}>
        <Button
          type="button"
          variant="contained"
          size="medium"
          color="primary"
          onClick={onAddClicked}
        >
          <Add />
          {t("common:add")}
        </Button>
      </Grid>
      <SearchedUserResult
        hitComponent={
          <AdminHit
            isSuper={isSuper}
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
            searchResult={searchResult}
          />
        }
      />
    </div>
  );
};

export default AdminsContainer;
